module.exports = __webpack_public_path__ + "static/media/submit-success-normal.cdfdd21e.png";